<div *ngIf="!!hub_messages && hub_messages.length > 0; else nomessages" style="display:block">
  <table class="message_actions">
    <tr class="header">
      <th class="created center" (click)="later()">Newer</th>
      <ng-container *ngIf="!!!inHub.hubid">
        <th class="hubid">Hub ID</th>
      </ng-container>
      <th class="sender_subject">Sender/<br>Subject</th>
      <th class="body_text">Body</th>
      <th class="message_type">Type</th>
      <th class="choices">Y/N</th>
      <th class="date_read_text center">Response At</th>
      <th class="response_text">Response</th>
    </tr>
    <ng-container *ngFor="let message of hub_messages">
      <tr class="{{getReadClass(message)}}">
        <td class="created"> {{message.created | godate}} </td>
        <ng-container *ngIf="!!!inHub.hubid">
          <td class="hubid">{{ message.hubid }}</td>
        </ng-container>
        <td class="sender_subject">{{message.from}}<br>{{message.subject}}</td>
        <td class="body_text">{{message.body}}</td>
        <td class="message_type">{{ getMessageType(message) }}</td>
        <td class="choices">
          <ng-container *ngIf="message.mail_type > 0">{{ message.positive }} / {{ message.negative }}</ng-container>
        </td>
        <td class="date_read_text">{{ readTime(message) | godate}}</td>
        <td class="response_text">{{ get_message_response(message) }}</td>
      </tr>
    </ng-container>
    <tr class="header">
      <th class="created center" (click)="earlier()">Earlier</th>
      <ng-container *ngIf="!!!inHub.hubid">
        <th class="hubid">Hub ID</th>
      </ng-container>
      <th class="sender_subject">Sender/<br>Subject</th>
      <th class="body_text">Body</th>
      <th class="message_type">Type</th>
      <th class="choices">Yes / No</th>
      <th class="date_read_text center">Response At</th>
      <th class="response_text">Response</th>
    </tr>
  </table>
</div>
<ng-template #nomessages>
  <br><br>No Messages<br>
</ng-template>